import { ExtendedAxiosResponse, apiClient } from 'helpers/apiClient';

export const api = {
  getData: (
    url: string,
    invoiceNumber: string,
    productNo?: string,
    posNext?: number,
    pageSize?: number
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/detail-list/getData`, {
      params: {
        invoicenumber: invoiceNumber,
        productNo: productNo,
        posNext: posNext,
        pageSize: pageSize,
      },
    }),
  lazyload: (
    url: string,
    invoiceNumber: string,
    productNo?: string,
    posNext?: number,
    pageSize?: number
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/detail-list/lazyload`, {
      params: {
        invoicenumber: invoiceNumber,
        productNo: productNo,
        posNext: posNext,
        pageSize: pageSize,
      },
    }),
  testLang: (url: string): Promise<ExtendedAxiosResponse> => apiClient.post(`${url}/detail-list/language`),
};
